export default "__VITE_ASSET__BJ4Az3qt__"